'use client';

import { SupportIllustration } from './SupportIllustration';

/**
 * Le bouton flottant du support (P01), en bas a droite. Dans l'editeur, il se tient au coin de la zone de dessin :
 * au-dessus de la barre du bas, a gauche du panneau des proprietes (qu'il masquerait sinon). Il s'y reduit a
 * l'illustration pendant qu'un outil de dessin est actif ; le libelle revient au survol.
 */
export function SupportButton({ onClick, inEditor, compact, unread = 0 }: { onClick: () => void; inEditor: boolean; compact: boolean; unread?: number }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title="Besoin d'aide ? Écrivez-nous"
      data-support="button"
      style={inEditor ? { bottom: 'calc(var(--bb-h) + 16px)', right: 'calc(var(--pane-r) + 16px)' } : { bottom: 20, right: 20 }}
      className={`group fixed z-[900] flex items-center gap-2.5 rounded-full border border-[var(--ink-200)] bg-[var(--paper)] py-1.5 pl-1.5 text-[12.5px] font-bold text-[var(--ink-800)] shadow-lg transition-shadow hover:border-[var(--accent-100)] hover:shadow-xl ${compact ? 'pr-1.5 hover:pr-3.5' : 'pr-3.5'}`}
    >
      <span className="relative grid h-10 w-10 place-items-center rounded-full bg-[var(--accent-50)]">
        <SupportIllustration size={34} />
        {unread > 0 && (
          <span aria-label={`${unread} réponse${unread > 1 ? 's' : ''} non lue${unread > 1 ? 's' : ''}`}
            className="absolute -right-2.5 -top-2 grid h-[18px] min-w-[18px] place-items-center rounded-full border-2 border-white bg-[var(--danger)] px-1 text-[10.5px] font-bold text-white">
            {unread}
          </span>
        )}
      </span>
      <span className={compact ? 'hidden group-hover:inline' : ''}>Besoin d&apos;aide ?</span>
    </button>
  );
}
